module.exports = __webpack_public_path__ + "img/base_activites_vtt_descente.5b4cd7f5.svg";